import React from 'react';
import './style.scss';
import './themed.scss';

const Notice = ({ active, severity, children }) => {
  let classes = ['notice', `notice-${ severity }`].join(' ')
  return (
    <dialog className={ classes } data-active={ active }>
      { children }
    </dialog>
  )
}

export default Notice